import SwalCustom from '../../alert/swal-custom'

function Error_false({ msg }, t) {
  return SwalCustom({
    imageWarning: true,
    title: t ? t(msg) : msg || 'เกิดข้อผิดพลาด',
    text: `กรุณาบันทึกภาพหน้าจอ แล้วแจ้ง IT เพื่อแก้ไขปัญหา `,
    confirmButtonColor: '#2c5dfe',
    confirmButtonText: 'OK'
  })
}

export default Error_false
